import $ from 'jquery';
require('owl.carousel');

var heroCarousel = $('.hero-carousel');

heroCarousel.owlCarousel({
  navigation: false,
  slideSpeed: 5000,
  autoplay: true,
  loop: true,
  singleItem: true,
  dots: false,
  items: 1,
  pagination: false,
  onChanged: function (event) {
    const $carousel = $(event.target);
    const $targetSlide = $carousel.find('.jcb-hero-img').eq(event.item.index + 2);
    if ($targetSlide) {
      const $targetStyle = $targetSlide.prev('style');
      $targetStyle.html($targetStyle.html().replace('/**', '').replace('**/', ''));
    }
  },
});
